// extracted by mini-css-extract-plugin
module.exports = {"titleMain":"Title_titleMain__16Fi4","titleDot":"Title_titleDot__3VDZx"};